import BillingsOrderRailyTaxiRecalculateRequest, {
  BillingsOrderRailyTaxiRecalculateRequestBillingNode,
  BillingsOrderRailyTaxiRecalculateRequestBonusType,
  BillingsOrderRailyTaxiRecalculateRequestPenaltyType,
} from "../../../../../api/raily/billings/order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate.request";
import BillingsOrderRailyTaxiRecalculateParams, {
  BillingsOrderRailyTaxiRecalculateParamsBillingNode,
  BillingsOrderRailyTaxiRecalculateParamsBonusType,
  BillingsOrderRailyTaxiRecalculateParamsPenaltyType,
} from "./billings-order-raily-taxi-recalculate-params";

const createBillingNode = (
  node: BillingsOrderRailyTaxiRecalculateParamsBillingNode,
): BillingsOrderRailyTaxiRecalculateRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.uuid,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeUuid,
    plannedDistance: node.plannedDistance,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    orderId: node.orderUuid,
    plannedDate: node.plannedDate,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderRailyTaxiRecalculateParamsBillingNode[],
): BillingsOrderRailyTaxiRecalculateRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createBonusType = (
  bonusType: BillingsOrderRailyTaxiRecalculateParamsBonusType | undefined,
): BillingsOrderRailyTaxiRecalculateRequestBonusType | undefined => {
  switch (bonusType) {
    case BillingsOrderRailyTaxiRecalculateParamsBonusType.DISTANCE_RATE_CHANGED:
      return BillingsOrderRailyTaxiRecalculateRequestBonusType.DISTANCE_RATE_CHANGED;
    case BillingsOrderRailyTaxiRecalculateParamsBonusType.HALTING_RATE_CHANGED:
      return BillingsOrderRailyTaxiRecalculateRequestBonusType.HALTING_RATE_CHANGED;
    case BillingsOrderRailyTaxiRecalculateParamsBonusType.OTHER:
      return BillingsOrderRailyTaxiRecalculateRequestBonusType.OTHER;
    case BillingsOrderRailyTaxiRecalculateParamsBonusType.SHORT_ROUTE:
      return BillingsOrderRailyTaxiRecalculateRequestBonusType.SHORT_ROUTE;
    default:
      return undefined;
  }
};

const createPenaltyType = (
  penaltyType: BillingsOrderRailyTaxiRecalculateParamsPenaltyType | undefined,
): BillingsOrderRailyTaxiRecalculateRequestPenaltyType | undefined => {
  switch (penaltyType) {
    case BillingsOrderRailyTaxiRecalculateParamsPenaltyType.BEING_LATE:
      return BillingsOrderRailyTaxiRecalculateRequestPenaltyType.BEING_LATE;
    case BillingsOrderRailyTaxiRecalculateParamsPenaltyType.GUIDELINE_IGNORED:
      return BillingsOrderRailyTaxiRecalculateRequestPenaltyType.GUIDELINE_IGNORED;
    case BillingsOrderRailyTaxiRecalculateParamsPenaltyType.HIGHWAY_NOT_ALLOWED:
      return BillingsOrderRailyTaxiRecalculateRequestPenaltyType.HIGHWAY_NOT_ALLOWED;
    case BillingsOrderRailyTaxiRecalculateParamsPenaltyType.INCOMPATIBLE_CAR:
      return BillingsOrderRailyTaxiRecalculateRequestPenaltyType.INCOMPATIBLE_CAR;
    case BillingsOrderRailyTaxiRecalculateParamsPenaltyType.OPTIMIZATION_REFUSED:
      return BillingsOrderRailyTaxiRecalculateRequestPenaltyType.OPTIMIZATION_REFUSED;
    case BillingsOrderRailyTaxiRecalculateParamsPenaltyType.OTHER:
      return BillingsOrderRailyTaxiRecalculateRequestPenaltyType.OTHER;
    case BillingsOrderRailyTaxiRecalculateParamsPenaltyType.SUBOPTIMAL_RIDE:
      return BillingsOrderRailyTaxiRecalculateRequestPenaltyType.SUBOPTIMAL_RIDE;
    default:
      return undefined;
  }
};

const createRequest = (
  params: BillingsOrderRailyTaxiRecalculateParams,
): BillingsOrderRailyTaxiRecalculateRequest => {
  return {
    orderUuid: params.orderUuid,
    billingNodes: createBillingNodes(params.billingNodes),
    bonus: params.bonus,
    penalty: params.penalty,
    bonusType: createBonusType(params.bonusType),
    penaltyType: createPenaltyType(params.penaltyType),
  };
};

const billingsOrderRailyTaxiRecalculateParamsFactory = {
  createRequest,
};

export default billingsOrderRailyTaxiRecalculateParamsFactory;
